import { Credentials, UserChecker, UserCheckResult, User } from 'authorization';
import { concat, Observable, of } from 'rxjs';
import { RequestDataAccessServiceConfig } from '../request-data-access.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, toArray } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class CouchDbUserChecker extends UserChecker {
  constructor(private _httpClient: HttpClient, private _config: RequestDataAccessServiceConfig) {
    super();
  }

  check(credentials: Credentials): Observable<UserCheckResult> {
    const checkQueryUrl = this._config.getServerURL() + 'requests';
    const checkRoleQuery = this._config.getServerURL() + '_users/_find';

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + credentials.asEncodedString,
      }),
    };
    return concat(
      this._httpClient.get(checkQueryUrl, options), // 0
      this._httpClient.post(checkRoleQuery, { selector: { name: credentials.login } }, options),
    ) // 1
      .pipe(
        toArray(),
        map((responses: any) => {
          const isAdmin = responses[1].docs.length === 0;
          return new UserCheckResult(new User(credentials, isAdmin), true);
        }),
        catchError((err) => of(new UserCheckResult(new User(credentials, false), err.status === 403))),
      );
  }
}
